import ajax from '../utils/request';

const businessmanApi = {
  /********************************代充，商人管理*********************************** */
  /**
   * 编辑商人
   * @param {*} params 
   * @param {String} params.uid 商户id 
   * @param {String} params.name 账户名 
   * @param {String} params.password 密码 
   * @param {String} params.nickname 昵称 
   * @param {String} params.email 邮箱 
   * @param {String} params.mobile 手机号
   * @param {String} params.cid 商人所属聚商ID
   * @param {String} params.channel 商人所属渠道
   * @param {String} params.wechat 微信号码
   * @param {Number} params.balance 商人余额
   */
  editBusinessman(params) {
    return ajax({
      url: '/daichong/merchant/edit',
      type: 'post',
      params: params
    })
  },
  /**
   * 删除商人
   * @param {*} params 
   * @param {Array} params.uids  商人id
   */
  delBusinessman(params){
    return ajax({
      url:'/daichong/merchant/del',
      type:'delete',
      params,
      
    })
  },
/**
 * 商人列表
 * @param {*} params 
 * @param {String} params.uid 商户id 
 * @param {String} params.name 账户名 
 * @param {String} params.nickname 昵称 
 * @param {String} params.mobile 手机号
 * @param {String} params.cid 商人所属聚商ID
 * @param {String} params.channel 商人所属渠道
 * @param {Number} params.pageNumber 当前页
 * @param {Number} params.pageSize 每页条数
 */
  getBusinessmanList(params) {
    return ajax({
      url:'/daichong/merchant/list',
      type:'get',
      params
    })
  },
  /**
   * 增加商人
   * @param {*} params 
   * @param {String} params.name 账户名 
   * @param {String} params.password 密码 
   * @param {String} params.nickname 昵称 
   * @param {String} params.email 邮箱 
   * @param {String} params.mobile 手机号
   * @param {String} params.cid 商人所属聚商ID
   * @param {String} params.channel 商人所属渠道
   * @param {String} params.wechat 微信号码
   * @param {Number} params.balance 商人余额 
   */
  addBusinessman(params) {
    return ajax({
      url:'/daichong/merchant/add',
      type:'post',
      params,
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    })
  },
  //商人上分
  addOrDebitScore(params) {
    return ajax({
      url:'/daichong/merchant/addOrDebitScore',
      type:'post',
      params
    })
  },
// 商人追分
  seekScore(params) {
    return ajax({
      url:'/daichong/merchant/seekScore',
      type:'post',
      params
    })
  },  
// ----------------------聚商管理模块
  // 增
  addGatheringList(params) {
    return ajax({
      url: '/jushang/merchant/add',
      type: 'post',
      params
    })
  },
  // 删
  delGatheringList(params) {
    return ajax({
      url: '/jushang/merchant/del',
      type: 'delete',
      params
    })
  },
  // 改
  editGatheringList(params) {
    return ajax({
      url: '/jushang/merchant/edit',
      type: 'post',
      params
    })
  },
  // 查询
  getGatheringList(params) {
    return ajax({
      url: '/jushang/merchant/list',
      type: 'get',
      params
    })
  },
  // 商人余额信息
  businessblBalance(params) {
    return ajax({
      url: '/jushang/merchant/info',
      type: 'get',
      params
    })
  },
  // 商人上分
  onPointsGathering(params) {
    return ajax({
      url: '/jushang/merchant/addOrDebitScore',
      type: 'post',
      params
    })
  },
  // 商人追分
  chasePointsGathering(params) {
    return ajax({
      url: '/jushang/merchant/seekScore',
      type: 'post',
      params
    })
  },
  // 聚商商人上分列表
  JushangList(params) {
    return ajax({
      url: '/jushang/merchant/balanceList',
      type: 'get',
      params
    })
  },
}
  





export default businessmanApi;

